'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/appconfs", "/appconfs/list");
  $urlRouterProvider.when("/codeappconfs", "/codeappconfs/code");

  $stateProvider
    .state('appconfs', {
      url: '/appconfs',
      template: require('./appconfs.html'),
      authenticate: true
    })
    .state('appconfs.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'AppConfsListController',
      controllerAs: 'acListCtrl',
      authenticate: true
    })
    .state('appconfs.code', {
      url: '/code',
      template: require('./code/code.html'),
      controller: 'AppConfsCodeController',
      controllerAs: 'acCodeCtrl',
      authenticate: true
    })
    .state('appconfs.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'AppConfsShowController',
      controllerAs: 'acShowCtrl',
      authenticate: true
    })
    .state('appconfs.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'AppConfsAddController',
      controllerAs: 'acAddCtrl',
      authenticate: true
    })
    .state('appconfs.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'AppConfsEditController',
      controllerAs: 'acEditCtrl',
      authenticate: true
    })
    .state('appconfs.import', {
      url: '/import',
      template: require('./import/import.html'),
      controller: 'AppConfsImportController',
      controllerAs: 'acImportCtrl',
      authenticate: true
    });

    $stateProvider
    .state('codeappconfs', {
      url: '/codeappconfs',
      template: require('./appconfs.html'),
      authenticate: true
    })
    .state('codeappconfs.code', {
      url: '/code',
      template: require('./code/code.html'),
      controller: 'AppConfsCodeController',
      controllerAs: 'acCodeCtrl',
      authenticate: true
    })
    .state('codeappconfs.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'AppConfsShowController',
      controllerAs: 'acShowCtrl',
      authenticate: true
    })
    .state('codeappconfs.add', {
      url: '/add/:type',
      template: require('./add/add.html'),
      controller: 'AppConfsAddController',
      controllerAs: 'acAddCtrl',
      authenticate: true
    })
    .state('codeappconfs.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'AppConfsEditController',
      controllerAs: 'acEditCtrl',
      authenticate: true
    })
}



// WEBPACK FOOTER //
// ./client/app/appconfs/appconfs.routes.js